/* DUFTWEISS · Aura Theme – Interaktionen */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header beim Scrollen ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Offene Drawer schließen, wenn ein anderer geöffnet wird / Escape
    var drawers = document.querySelectorAll('details.drawer');
    drawers.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          drawers.forEach(function (o) { if (o !== d) o.open = false; });
          var input = d.querySelector('input[type="search"]');
          if (input) setTimeout(function () { input.focus(); }, 60);
        }
        document.documentElement.style.overflow = document.querySelector('details.drawer--menu[open]') ? 'hidden' : '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drawers.forEach(function (d) { d.open = false; });
    });
  }

  /* ---------- Ankündigungsleiste ---------- */
  function initAnnouncements() {
    document.querySelectorAll('[data-announcements]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var items = bar.querySelectorAll('.announcement__item');
      if (items.length < 2 || reduceMotion) return;
      var i = 0;
      setInterval(function () {
        var cur = items[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 700);
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    });
  }

  /* ---------- Hero-Diashow ---------- */
  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var slides = root.querySelectorAll('.hero__slide');
      var bars = root.querySelectorAll('.hero__bar');
      var coords = root.querySelectorAll('.hero__coords span');
      var counter = root.querySelector('[data-counter]');
      var speed = parseFloat(root.getAttribute('data-speed') || '7') * 1000;
      var autoplay = root.hasAttribute('data-autoplay') && !reduceMotion && slides.length > 1;
      var index = 0;
      var timer = null;
      var paused = false;

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var active = k === index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = active ? 0 : -1; });
        });
        bars.forEach(function (b, k) {
          b.classList.remove('is-active');
          b.classList.toggle('is-done', k < index);
          b.setAttribute('aria-current', k === index ? 'true' : 'false');
        });
        if (bars[index]) { void bars[index].offsetWidth; bars[index].classList.add('is-active'); }
        coords.forEach(function (c, k) { c.classList.toggle('is-active', k === index); });
        if (counter) counter.textContent = pad(index + 1) + ' / ' + pad(slides.length);
        schedule();
      }

      function schedule() {
        clearTimeout(timer);
        if (autoplay && !paused) timer = setTimeout(function () { go(index + 1); }, speed);
      }

      function pause(state) {
        paused = state;
        root.classList.toggle('is-paused', state);
        if (state) clearTimeout(timer); else schedule();
      }

      root.style.setProperty('--speed', speed / 1000 + 's');
      if (!autoplay) root.classList.add('is-paused');

      bars.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      root.addEventListener('mouseenter', function () { if (autoplay) pause(true); });
      root.addEventListener('mouseleave', function () { if (autoplay) pause(false); });
      root.addEventListener('focusin', function () { if (autoplay) pause(true); });
      root.addEventListener('focusout', function () { if (autoplay) pause(false); });

      // Wischen auf dem Handy
      var startX = null;
      root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      // Theme-Editor: ausgewählte Folie anzeigen
      document.addEventListener('shopify:block:select', function (e) {
        var target = root.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        if (!target) return;
        pause(true);
        go(Array.prototype.indexOf.call(slides, target));
      });
      document.addEventListener('shopify:block:deselect', function () { if (autoplay) pause(false); });

      go(0);
    });
  }

  /* ---------- Einblenden beim Scrollen ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Warenkorb ---------- */
  function updateCartCount() {
    return fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  var toastTimer;
  function showToast(text) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-text]').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  function initAjaxForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[data-ajax-cart]')) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      var title = form.getAttribute('data-product-title') || 'Duft';

      fetch(window.theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
          if (button) {
            button.classList.add('is-added');
            setTimeout(function () { button.classList.remove('is-added'); }, 1800);
          }
          showToast(title + ' liegt im Warenkorb.');
          return updateCartCount();
        })
        .catch(function (err) { showToast(err.message || 'Das hat leider nicht geklappt.'); })
        .finally(function () {
          if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
        });
    });
  }

  /* ---------- Mengenfelder ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var val = parseInt(input.value || '1', 10) + (btn.getAttribute('data-qty') === 'plus' ? 1 : -1);
      input.value = Math.max(min, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) {
        var form = e.target.closest('form');
        clearTimeout(form._t);
        form._t = setTimeout(function () { form.submit(); }, 450);
      }
    });
  }

  /* ---------- Varianten ---------- */
  function initVariants() {
    document.querySelectorAll('[data-product-form-root]').forEach(function (root) {
      var jsonEl = root.querySelector('[data-variants-json]');
      if (!jsonEl) return;
      var variants = JSON.parse(jsonEl.textContent);
      var sectionId = root.getAttribute('data-section-id');
      root.addEventListener('change', function (e) {
        if (!e.target.closest('.variant-picker')) return;
        var selected = Array.prototype.map.call(root.querySelectorAll('.variant-picker'), function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        var idInput = root.querySelector('input[name="id"]');
        var submit = root.querySelector('[data-add-button]');
        if (!variant) {
          if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.querySelector('span').textContent = 'Nicht verfügbar'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (submit) {
          submit.toggleAttribute('aria-disabled', !variant.available);
          submit.querySelector('span').textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        fetch(url.pathname + '?variant=' + variant.id + '&section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-price-wrapper]');
            var current = root.querySelector('[data-price-wrapper]');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
      });
    });
  }

  /* ---------- Sortierung ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Produktempfehlungen ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
            el.querySelectorAll('[data-reveal]').forEach(function (r) { r.classList.add('is-visible'); });
          }
        });
    });
  }

  /* ---------- Mobile Kaufleiste ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var main = document.querySelector('[data-main-add]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.site-footer');
    var mainVisible = true, footerVisible = false;
    var update = function () {
      var show = !mainVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    };
    new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0; update(); }).observe(main);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; update(); }).observe(footer);
  }

  function init() {
    initHeader();
    initAnnouncements();
    initSlideshows();
    initReveal();
    initAjaxForms();
    initQuantity();
    initVariants();
    initSort();
    initRecommendations();
    initStickyBuy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    initSlideshows();
    initReveal();
    initAnnouncements();
  });
})();
